import { Pagination } from 'src/app/shared/interfaces/pagination';

/**
 * @description
 * Classe abstrata de tabela
 */
export abstract class CarbonTable<T> {

  public pagination: Pagination<T> = {
    page: 1,
    size: 5,
    results: [{}] as T[]
  }

  public totalPages: number = 0;
  public totalItens: number = 0;
  public itens: T[] = [];
  abstract onPageChange(currentPage: number): void;

  resetPagination(): void {
    this.pagination = {
      page: 1,
      size: 5,
      results: [{}] as T[]
    }
  }

  handleTotalPages(event: any) {
    if(event?.pageSize) {
      this.totalPages =  Math.ceil((this.totalItens ?? 0) / event?.pageSize);
      if(this.pagination.size != event?.pageSize){
        this.pagination.size = event?.pageSize;
      }
    } else {
      this.totalPages = Math.ceil((this.totalItens ?? 0) / (this.pagination.size ?? 5));
    }
  }


}
